import RegularButton from "components/CustomButtons/Button";
import React from "react"


import VisibilityIcon from '@mui/icons-material/Visibility';
import VisibilityOffIcon from '@mui/icons-material/VisibilityOff';

const colors = {
    success: '#4caf50',
    error: '#f6685e',
    info: '#4092E5'
}
const status = {
    'Pendiente': '#4092E5',
    'En Oracle': '#4caf50',
    'Rechazado': '#f6685e',
    'Parcialmente en Oracle': '#ff9800'
}


export const columnsListReq = [
    {
        "Header": "Folio",
        "accessor": "folio",
        "filterable": true,
        "filterMethod": (filter, row) => { return row.folio?.toLowerCase().includes(filter.value.toLowerCase()); }
    },
    {
        "Header": "Artículos",
        "accessor": "numberItem",
        "filterable": true,
    },
    {
        "Header": "Estatus General",
        "accessor": "statusEsp",
        "filterable": true,
        "filterMethod": (filter, row) => {
            return row.statusEsp?.toLowerCase().includes(filter.value.toLowerCase())
        },
        getProps: (state, rowInfo, column) => {
            return {
                style: {
                    color: rowInfo?.original && status[rowInfo?.original.statusEsp],
                },

            };
        },
    },
    {
        "Header": "Fecha Solicitud",
        "accessor": "dateCreate",
        "filterable": true,
        "filterMethod": (filter, row) => {
            return row.dateCreate?.toLowerCase().includes(filter.value.toLowerCase())
        }
    },
    {
        "Header": "Usuario",
        "accessor": "userName",
        "filterable": true,
        "filterMethod": (filter, row) => {
            return row.userName?.toLowerCase().includes(filter.value.toLowerCase())
        }
    },
    {
        "Header": "Tipo de solicitud",
        "accessor": "typeEsp",
        "filterable": true,
        "filterMethod": (filter, row) => {
            return row.typeEsp?.toLowerCase().includes(filter.value.toLowerCase())
        }
    },
    {
        "Header": "Acciones",
        "filterable": true,
        expander: true,
        width: 100,
        Expander: ({ isExpanded, ...rest }) =>
            <>
                {isExpanded
                    ? <RegularButton
                        color="transparent"
                        round
                        justIcon
                        tooltip="Ocultar Detalles"
                        style={{ float: 'right' }}
                    >
                        <VisibilityOffIcon style={{ margin: 0, color: colors.error }} />
                    </RegularButton>
                    : <RegularButton
                        color="transparent"
                        round
                        justIcon
                        tooltip="Mostrar Detalles"
                        style={{
                            float: 'right'
                        }}
                    >
                        <VisibilityIcon style={{ margin: 0, color: colors.info }} />
                    </RegularButton>
                }
            </>,
    }]